import { Http } from '../../../common/api';
import { BaseApiConfiguration } from '../../../common/models';

export const webStoreHttp = new Http();

export const initializeWebStoreHttp = (config: BaseApiConfiguration): void => {
  webStoreHttp.initializeHttp(config.baseUrl);
};
